// extracted by mini-css-extract-plugin
module.exports = {"percentInput":"percentInput_percentInput__1fYYQ"};